import { useState, useEffect } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import request from "../../../utilities/requests";

const DoneDialog = ({ open, close }) => {
  const [finalRoundMessage, setFinalRoundMessage] = useState({
    title: "",
    body: "",
  });

  useEffect(() => {
    if (!open) return;
    getMessage();
  }, [open]);

  const getMessage = async () => {
    const result = await request("pairingEvent/finalroundmessage");
    if (result.success) {
      setFinalRoundMessage(result.finalRoundMessage);
    } else {
      close();
    }
  };

  return (
    <Dialog open={open} onClose={() => close()}>
      <DialogTitle>{finalRoundMessage?.title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{finalRoundMessage?.body}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => close()} autoFocus>
          Got it
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DoneDialog;
